"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTargetSegmentIntegration = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _analytics = _interopRequireDefault(require("@segment/analytics.js-integration"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TargetSegmentIntegration = (0, _analytics.default)('TargetSegmentIntegration').mapping('events');

TargetSegmentIntegration.prototype.initialize = function () {
  this.ready();
};

TargetSegmentIntegration.prototype.page = function (page) {
  if ((0, _get2.default)(window, 'adobe.target')) {
    var events = (0, _get2.default)(this, 'options.events.page', {});
    var eventName = (0, _get2.default)(page, 'obj.name', '');
    var eventProps = (0, _get2.default)(page, 'obj.properties', {});
    var metric = events[eventName];

    if (metric) {
      var target = window.adobe.target;
      target.trackEvent({
        mbox: 'analytics',
        params: _objectSpread(_objectSpread({
          eventName: eventName
        }, eventProps), metric)
      });
    }
  }
};

TargetSegmentIntegration.prototype.track = function (track) {
  if ((0, _get2.default)(window, 'adobe.target')) {
    var events = (0, _get2.default)(this, 'options.events.elements', []);
    var eventName = (0, _get2.default)(track, 'obj.event', '');
    var eventProps = (0, _get2.default)(track, 'obj.properties', {});
    var metric = events[eventName];

    if (metric) {
      var target = window.adobe.target;
      target.trackEvent({
        mbox: 'analytics',
        params: _objectSpread(_objectSpread({
          eventName: eventName
        }, eventProps), metric)
      });
    }
  }
};

var initTargetSegmentIntegration = function initTargetSegmentIntegration(metrics) {
  if (process.env.IS_BROWSER && (0, _get2.default)(window, 'analytics.addIntegration')) {
    var integrationInstance = new TargetSegmentIntegration({
      events: metrics
    });
    integrationInstance.initialize();
    window.analytics.add(integrationInstance);
  }
};

exports.initTargetSegmentIntegration = initTargetSegmentIntegration;
var _default = initTargetSegmentIntegration;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/target/TargetSegmentIntegration.js
// module id = 4457
// module chunks = 25